

import React from 'react'
import LayoutModal from '../../Layout/Dashboard/LayoutModal'
import FormServices from './FormServices'
import { useAddServices } from '../../api/Services'
import { getDataToSend, getInitialValues, getValidationSchema } from './formUtil'
import { QueryStatusEnum } from '../../config/QueryStatus'
import { useTranslation } from 'react-i18next'

function AddServicesModal() {


  const [t] = useTranslation()
  const {mutate , status} = useAddServices()
  const handelSubmit = (values:any )=>{

    const dataToSend = getDataToSend(values)

    mutate(dataToSend)
    // Submit Value
  }
  return (
    <LayoutModal
    
     isAddModal={true}
     getInitialValues={getInitialValues()} 
     handleSubmit={handelSubmit} 
     status={status as QueryStatusEnum}
     headerText={t('Add') +t('Services')}
     
     getValidationSchema={getValidationSchema()}>

    <FormServices />
  </LayoutModal>
  )
}

export default AddServicesModal

